import { render, staticRenderFns } from "./SocialLinksList.vue?vue&type=template&id=1761349d&scoped=true"
import script from "./SocialLinksList.vue?vue&type=script&lang=js"
export * from "./SocialLinksList.vue?vue&type=script&lang=js"
import style0 from "./SocialLinksList.vue?vue&type=style&index=0&id=1761349d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1761349d",
  null
  
)

export default component.exports